var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUperArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9846 0.691203C16.8406 0.478032 16.648 0.303737 16.4233 0.183326C16.1985 0.0629152 15.9485 1.34948e-06 15.6946 1.37168e-06C15.4407 1.39387e-06 15.1906 0.0629153 14.9659 0.183326C14.7412 0.303737 14.5485 0.478033 14.4046 0.691204L0.280401 21.4898C0.116913 21.7297 0.0210398 22.0106 0.00319848 22.3022C-0.0146428 22.5937 0.0462283 22.8847 0.179199 23.1434C0.31217 23.4022 0.512157 23.6188 0.757429 23.7698C1.0027 23.9209 1.28388 24.0005 1.57041 24L29.8188 24C30.1046 23.9988 30.3848 23.9182 30.6291 23.7668C30.8733 23.6154 31.0725 23.399 31.2052 23.1409C31.3378 22.8827 31.399 22.5926 31.382 22.3017C31.365 22.0107 31.2705 21.7301 31.1088 21.4898L16.9846 0.691203Z",
    fill: "#213C92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUperArrowIcon);
export default __webpack_public_path__ + "static/media/uper-arrow-icon.b6d35f010e06e57d2b6fcede853f2bc7.svg";
export { ForwardRef as ReactComponent };